import { EventBus } from "@/lib/event_bus";
import { setVueState } from "@/lib/vueStateBridge";

import { Channel } from "@anycable/web";

export default class VueChannel extends Channel {
  static identifier = "Admins::VueChannel";

  connected(id) {
    console.log("Connected to VueChannel " + id);

    super.connected(id);
  }

  receive(message) {
    switch (message.action) {
      case "vue_emit":
        return this.handleVueEmit(message);
      case "set_vue_state":
        return this.handleSetVueState(message);
    }

    // Fallback to the default behaviour
    super.receive(message);
  }

  handleSetVueState(message) {
    const { target, data } = message;
    return setVueState(target, JSON.parse(data));
  }

  handleVueEmit(message) {
    const { event, data } = message;
    return EventBus.$emit(event, JSON.parse(data));
  }
}
